export default __webpack_public_path__ + "static/fence-_emoval-e311407d5c953e6049f68e97368d97a3.jpg";